export default "__VITE_ASSET__B9F_ODYR__"